import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_SUB_DISTRICT_BEGIN, GET_SUB_DISTRICT_SUCCESS, CLEAR_SUB_DISTRICT } from "./type";
import { hasErrors } from "../../../error/actions";
import qs from "querystring";

export const getSubDistrict = (districtId) => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.ADDRESS.GET_SUB_DISTRICTS, {
                params: { districtId },
                paramsSerializer: (params) => {
                    return qs.stringify(params, { arrayFormat: 'brackets' })
                },
            })
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

export const clearSubDistrict = () => {
    return async dispatch => {
        dispatch({ type: CLEAR_SUB_DISTRICT })
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_SUB_DISTRICT_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_SUB_DISTRICT_SUCCESS, payload: { items, loading: false } })
    }
}